let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cugXI")).then(() => parcelRequire('hFglO'));